module.exports = __webpack_public_path__ + "static/background-hero-1-50f29546283a58088f0c779f3cb5fd9c.jpg";